<template>
    <b-modal ref="restorebackupmodal" centered lazy title="Restore website" ok-title="Save changes" @shown="loadBackup" @ok="restore()" :hide-header-close="true" no-fade>
        <div class="prompt-text" v-if="!backup.newBackupMethod">
            Are you sure you want to proceed with this?
        </div>
        <div class="prompt-text" v-if="backup.newBackupMethod">
            Select what do you want to restore?
        </div>
        <div class="prompt-selection" v-if="backup.newBackupMethod && (backup.what!='DB' && backup.what !='db')">
            <b-form-group>
                <b-form-checkbox-group stacked id="checkboxes1" name="flavour1" v-model="selected" :options="options">
                </b-form-checkbox-group>
            </b-form-group>
        </div>
        <div class="prompt-selection" v-if="backup.newBackupMethod && (backup.what =='DB' || backup.what =='db')">
            <b-form-group>
                <b-form-checkbox-group stacked id="checkboxes1" name="flavour1" v-model="selected2" :options="options2">
                </b-form-checkbox-group>
            </b-form-group>
        </div>
        <div slot="modal-footer" class="w-100">
            <p class="float-left note">This action cannot be undone.</p>
            <div class="float-right">
                <b-btn variant="flat" @click="close">
                    Not now
                </b-btn>
                <b-btn variant="primary" @click="restore">
                    Restore
                </b-btn>
            </div>

        </div>
    </b-modal>
</template>

<script>
export default {
  name: "restorebackup",
  props: ["backup"],
  data() {
    return {
      selected: ["plugins", "themes", "uploads", "db", "others", "more"],
      selected2: ["db"],
      options: [
        {
          text: "Plugins",
          value: "plugins"
        },
        {
          text: "Themes",
          value: "themes"
        },
        {
          text: "Uploads",
          value: "uploads"
        },
        {
          text: "Database",
          value: "db"
        },
        {
          text: "Other (Other folders except uploads in wp-content)",
          value: "others"
        },
        {
          text:
            "More (wp-config, .htaccess and other folders in the WP folder, if you have included any)",
          value: "more"
        },
        {
          text: "Wordpress",
          value: "wp"
        },
        {
          text: "Restore via FTP",
          value: "ftp"
        }
      ],
      options2: [
        {
          text: "Database",
          value: "db"
        },
        {
          text: "Restore via FTP",
          value: "ftp"
        }
      ]
    };
  },
  methods: {
    close() {
      this.$refs.restorebackupmodal.hide();
    },
    restore() {
      console.log(this.backup);
      let payload = {};
      payload.args = {};
      payload.args.siteIDs = [];
      payload.args.siteIDs.push(this.backup.siteID);
      payload.args.params = {
        taskName: this.backup.task_name,
        resultID: this.backup.referenceKey,
        backupFileBasename: this.backup.backupFileBasename
      };
      if (this.backup.repo=='Server') {
        payload.action = "restoreBridgeUpload";
      }else{
        payload.args.params.isCloudBackup = true;
        payload.action = "restoreBackupDownlaod";
      }
      
      if (this.backup.newBackupMethod) {
        payload.args.params.isNewBackup = true;
        if (this.backup.what == "db" || this.backup.what == "DB") {
          payload.args.params.types_to_downlaod = this.selected2;
        }else{
          payload.args.params.types_to_downlaod = this.selected;
        }
      }
      console.log(payload);
      this.$store.dispatch("sendAction", payload);
      this.close();
    },
    loadBackup() {
      

      if (this.backup.newBackupMethod) {
        let payload = {};
        payload.requiredData = {
          getNewBackupDetails: {
            siteId: this.backup.siteID,
            taskName: this.backup.backupName,
            backupID: this.backup.referenceKey,
            backupFileBasename: this.backup.backupFileBasename
          }
        };
        this.$store.dispatch("sendAction", payload).then(response => {
          let getNewBackupDetails = response.data.getNewBackupDetails;
          
          
        });
      }
    }
  }
};
</script>

<style scoped>
/* .prompt-text{
  padding: 44px;
} */

</style>
